import ls from 'local-storage'
import moment from 'moment'
import _ from 'lodash'
import 'string_score'
import chunk from '../functions/global_functions'

export const localStorageMixin = {
    methods: {
        ls_pushUser (user) {
            ls.set('user', user)
        },

        ls_pullUser () {
            return ls.get('user')
        },

        ls_logOut () {
            return ls.clear()
        }
    }
}

export const noteMixin = {
    methods: {
        createNote (id, name, body = '', dateModified = moment()) {
            return {
                id: id,
                name: name,
                body: body,
                date_modified: dateModified.toString(),
                date_created: moment().toString(),
                is_public: false
            }
        },

        findKeyForContactId (contactId, contacts) {
            return _.findKey(contacts, {'id': contactId})
        },

        findKeyForNoteId (noteId, notes) {
            return _.findKey(notes, {'id': noteId})
        },

        nextIdForNotes (notes) {
            const ids = _.map(notes, (note) => { return note.id })
            return ids.length > 0 ? Math.max(...ids) + 1 : 1
        },

        filterContactsForQuery (query, contacts) {
            return _.filter(contacts, (contact) => {
                const queryLower = query.toLowerCase()
                const nameScore = contact.name.toLowerCase().score(queryLower)
                const bodyScore = contact.body.toLowerCase().score(queryLower)
                contact.score = nameScore + bodyScore
                return nameScore > 0 || bodyScore > 0
            })
        },

        filterNotesForQuery (query, notes) {
            return _.filter(notes, (note) => {
                const queryLower = query.toLowerCase()
                const nameScore = note.name.toLowerCase().score(queryLower)
                const bodyScore = note.body.toLowerCase().score(queryLower)
                note.score = nameScore + bodyScore
                return nameScore > 0 || bodyScore > 0
            })
        },

        sortContacts (contacts, useScore) {
            let now = moment()
            if (useScore)
                return _.orderBy(contacts, ['score', (contact) => this.secondsFromNow(now, contact.date_modified)], ['desc', 'asc'])
            else
                return _.orderBy(contacts, [(note) => this.secondsFromNow(now, note.date_modified)], ['asc'])
        },

        sortNotes (notes, useScore) {
            let now = moment()
            if (useScore)
                return _.orderBy(notes, ['score', (note) => this.secondsFromNow(now, note.date_modified)], ['desc', 'asc'])
            else
                return _.orderBy(notes, [(note) => this.secondsFromNow(now, note.date_modified)], ['asc'])
        },

        secondsFromNow (now, dateString) {
            const date = moment(dateString)
            return now.diff(date, 'seconds')
        }
    }
}

export const utilsMixin = {
    methods: {
        selectElement (selector) {
            return document.querySelector(`${selector}`)
        },

        focusElement (selector) {
            const element = this.selectElement(selector)
            element.focus()
        },

        pad (num, size) {
            let s = num + ''
            while (s.length < size) s = '0' + s
            return s
        }
    }
}

export const typeCheckMixin = {
    methods: {
        check_undefined (myVar) {
            if (typeof myVar !== 'undefined') {
                return myVar
            } else {
                return null
            }
        },
        check_undefined_get_number (myVar) {
            if (typeof myVar !== 'undefined') {
                return myVar
            } else {
                return 0
            }
        }
    }
}

export const colorMixin = {
    methods: {
        getColor (value) {
            //value from 0 to 1
            if (isNaN(value)) {
                value = 0.5
            }
            let hue = ((1 - value) * 120).toString(10)
            return ['hsl(', hue, ',80%,80%)'].join('')
        }
    }
}

export const objectsMixin = {
    methods: {
        object_to_array (object) {
            // console.log('yeah')
            // console.log(object)
            return _.values(object)
        },
        object_length (object) {
            return _.keys(object).length
        }
    }
}

export const mathMixin = {
    methods: {
        roundToTwo (num) {
            return +(Math.round(num + 'e+2') + 'e-2')
        },
        calcMax: function (array) {
            return Math.max.apply(null, array)
        },

        calcMin: function (array) {
            return Math.min.apply(null, array)
        },

        calcRange: function (array) {
            return this.this.calcMax(array) - this.calcMin(array)
        },

        calcMidRange: function (array) {
            return this.calcRange(array) / 2
        },

        calcSum: function (array) {
            let num = 0
            for (let i = 0, l = array.length; i < l; i++) num += array[i]
            return num
        },

        calcMean: function (array) {
            return this.calcSum(array) / array.length
        },

        calcMedian: function (array) {
            array.sort(function (a, b) {
                return a - b
            })
            let mid = array.length / 2
            return mid % 1 ? array[mid - 0.5] : (array[mid - 1] + array[mid]) / 2
        },

        calcModes: function (array) {
            if (!array.length) return []
            let modeMap = {},
                maxCount = 0,
                modes = []

            array.forEach(function (val) {
                if (!modeMap[val]) modeMap[val] = 1
                else modeMap[val]++

                if (modeMap[val] > maxCount) {
                    modes = [val]
                    maxCount = modeMap[val]
                }
                else if (modeMap[val] === maxCount) {
                    modes.push(val)
                    maxCount = modeMap[val]
                }
            })
            return modes
        },

        calcLetiance: function (array) {
            let mean = this.calcMean(array)
            return this.calcMean(array.map(function (num) {
                return Math.pow(num - mean, 2)
            }))
        },

        calcStandardDeviation: function (array) {
            return Math.sqrt(this.calcLetiance(array))
        },

        calcMeanAbsoluteDeviation: function (array) {
            let mean = this.calcMean(array)
            return this.calcMean(array.map(function (num) {
                return Math.abs(num - mean)
            }))
        },

        calcZScores: function (array) {
            let mean = this.calcMean(array)
            let standardDeviation = this.calcStandardDeviation(array)
            return array.map(function (num) {
                return (num - mean) / standardDeviation
            })
        }
    }
}

export const dateMixin = {
    methods: {
        date_to_millis (date) {
            return moment(date, 'YYYY-MM-DD').format('x')
        },
        millis_to_date (date_in_milliseconds) {
            return moment(date_in_milliseconds).format('DD/MM/YYYY')
        },
        millis_to_time (date_in_milliseconds) {
            return moment(date_in_milliseconds).format('DD/MM/YYYY HH:mm:ss')
        }
    }
}

export const dataURLMixin = {
    methods: {
        canvasToDataURL (src, callback, outputFormat) {
            console.log('***** src: ')
            console.log(src)
            let img = new Image()
            img.crossOrigin = 'Anonymous'
            img.onload = function () {
                let canvas = document.createElement('CANVAS')
                let ctx = canvas.getContext('2d')
                let dataURL
                canvas.height = this.naturalHeight
                canvas.width = this.naturalWidth
                ctx.drawImage(this, 0, 0)
                dataURL = canvas.toDataURL(outputFormat)
                callback(dataURL)
            }
            img.src = src
            if (img.complete || img.complete === undefined) {
                img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
                img.src = src
            }
        }
    }
}

export const geohashMixin = {
    methods: {
        chunk
    }
}

export const appraisalCalcMixin = {
    methods: {
        calcAppraisal: function (appraisal, market_id, market_value, market_unit_value) {

            //// Paràmetres per defecte de Càlcul Valors Tècnics -------------------------

            appraisal['marketstudy_id'] = market_id
            appraisal['market_value'] = market_value
            appraisal['market_unit_value'] = market_unit_value

            if (!appraisal['market_value_appraiser_adjustment_pct']) {
                // DEFAULT_VALUE
                appraisal['market_value_appraiser_adjustment_pct'] = 100
            }

            appraisal['adopted_market_value'] = this.roundToTwo(appraisal['market_value'] * ( appraisal['market_value_appraiser_adjustment_pct'] / 100 ))
            appraisal['adopted_market_unit_value'] = this.roundToTwo(appraisal['market_unit_value'] * ( appraisal['market_value_appraiser_adjustment_pct'] / 100 ))

            if (!appraisal['expenses_and_industrial_benefit_bec_pct']) {
                appraisal['expenses_and_industrial_benefit_bec_pct'] = 20
            }

            if (!appraisal['useful_life_years'] || appraisal['useful_life_years'] === 0) {
                appraisal['useful_life_years'] = 100
            }

            if (!appraisal['remaining_useful_life_years']) {
                appraisal['remaining_useful_life_years'] = appraisal['useful_life_years']
            }

            if (!appraisal['construction_year'] && !appraisal['last_renovation_year'] && appraisal['adopted_age']) {
                appraisal['construction_year'] = appraisal['adopted_age']
                appraisal['last_renovation_year'] = appraisal['adopted_age']
            } else if (!appraisal['construction_year'] && !appraisal['last_renovation_year'] && !appraisal['adopted_age']) {
                // DEFAULT AGE
                appraisal['construction_year'] = 1970
                appraisal['last_renovation_year'] = 1970
                appraisal['adopted_age'] = 1970
            } else {
                let age_average = Math.floor((appraisal['construction_year'] + appraisal['last_renovation_year']) / 2)
                let appraisal_year = moment(appraisal['appraisaldate']).format('YYYY')
                appraisal['adopted_age'] = age_average
                appraisal['adopted_age_years_old'] = Number(appraisal_year) - age_average
            }

            console.log('(appraisal[\'appraisaldate\']: ')
            console.log(appraisal['appraisaldate'])


            let appraisal_year = moment(appraisal['appraisaldate']).format('YYYY')
            appraisal['adopted_age_years_old'] = appraisal_year - appraisal['adopted_age']

            appraisal['remaining_useful_life_years'] = appraisal['useful_life_years'] - appraisal['adopted_age_years_old']
            appraisal['physical_depreciation_pct'] = this.roundToTwo((appraisal['adopted_age_years_old'] / appraisal['useful_life_years']) * 100)

            if (!appraisal['functional_depreciation_pct']) {
                appraisal['functional_depreciation_pct'] = 0
            }

            appraisal['total_depreciation_pct'] = this.roundToTwo((  (100 - appraisal['physical_depreciation_pct']) * (100 - appraisal['functional_depreciation_pct']) ) / 100)

            if (!appraisal['total_construction_progress_pct']) {
                appraisal['total_construction_progress_pct'] = 100
            }else if (appraisal['total_construction_progress_pct'] < 100) {
                // si l'edifici està en obres la depreciació física ha de ser 0!
                appraisal['physical_depreciation_pct'] = 100
                appraisal['total_depreciation_pct'] = 100
            }

            // console.log('physical_depreciation_pct: ')
            // console.log(appraisal['physical_depreciation_pct'])

            // console.log('functional_depreciation_pct: ')
            // console.log(appraisal['functional_depreciation_pct'])

            // console.log('total_depreciation_pct: ')
            // console.log(appraisal['total_depreciation_pct'])

            if (!appraisal['adjusted_bec_price']) {
                // DEFAULT_VALUE
                appraisal['adjusted_bec_price'] = 1200
            }

            if (!appraisal['material_execution_cost']) {
                // DEFAULT_VALUE
                appraisal['material_execution_cost'] = 1000
            }

            // ccb: Cost de Construcció a Nou (Cost de Construcció Brut)
            appraisal['ccb'] = appraisal['adjusted_bec_price']
            console.log('ccb: ')
            appraisal['ccb']

            if (!appraisal['mec_adjustment_coef']) {
                // DEFAULT_VALUE
                appraisal['mec_adjustment_coef'] = 1
            }

            if (!appraisal['bc_pct']) {
                // Benefici industrial tipus del constructor
                appraisal['bc_pct'] = 6
            }

            if (!appraisal['gc_pct']) {
                // Despeses generals del constructor
                appraisal['gc_pct'] = 14
            }

            if (!appraisal['htl_pct']) {
                // Honoraris facultatius, taxes i llicències
                appraisal['htl_pct'] = 12
            }

            if (!appraisal['inr_pct']) {
                // Impostos no recuperables
                appraisal['inr_pct'] = 10
            }

            if (!appraisal['ga_pct']) {
                // Despeses d'administrador del promotor
                appraisal['ga_pct'] = 4
            }

            if (!appraisal['gpd_pct']) {
                // Despeses de pòlissa decennal
                appraisal['gpd_pct'] = 0.65
            }

            if (!appraisal['oct_pct']) {
                // OCT
                appraisal['oct_pct'] = 1.35
            }

            // Despeses de promoció
            appraisal['gp_pct'] = appraisal['htl_pct'] + appraisal['inr_pct'] + appraisal['ga_pct'] + appraisal['gpd_pct'] + appraisal['oct_pct']

            if (!appraisal['tlr_pct']) {
                // Taxa lliure de risc (Rendibilitat mitjana anual del deute de l'estat a un termini no inferior a 2 anys)
                appraisal['tlr_pct'] = 4
            }

            //// Prima de risc segons EHA/3011/2007
            // Habitatges primera residència --> 8%
            // Habitatges segona residència --> 12%
            // Edificis d'oficines --> 10%
            // Edificis comercials --> 12%
            // Edificis industrials --> 14%
            // Places d'aparcament --> 9%
            // Hotels --> 11%
            // Residències estudiants i 3ª edat --> 12%
            // Altres --> 12%

            if (!appraisal['pr_pct']) {
                // Prima de risc
                appraisal['pr_pct'] = 8
            }

            if (appraisal['property_type'].name_es === 'Piso') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Ático') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Sobreático') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Bajos') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Apartamento') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Loft') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Estudio') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Dúplex') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Triplex') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Plaza de aparcamiento') {
                appraisal['pr_pct'] = 9
            } else if (appraisal['property_type'].name_es === 'Garaje') {
                appraisal['pr_pct'] = 9
            } else if (appraisal['property_type'].name_es === 'Casa adosada') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Casa independiente') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Finca rústica') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Masía') {
                appraisal['pr_pct'] = 8
            } else if (appraisal['property_type'].name_es === 'Piscina') {
                appraisal['pr_pct'] = 12
            } else if (appraisal['property_type'].name_es === 'Trastero') {
                appraisal['pr_pct'] = 12
            } else if (appraisal['property_type'].name_es === 'Pista deportiva') {
                appraisal['pr_pct'] = 12
            } else if (appraisal['property_type'].name_es === 'Club deportivo') {
                appraisal['pr_pct'] = 12
            } else if (appraisal['property_type'].name_es === 'Local con acceso directo') {
                appraisal['pr_pct'] = 12
            } else if (appraisal['property_type'].name_es === 'Local sin acceso directo') {
                appraisal['pr_pct'] = 12
            } else if (appraisal['property_type'].name_es === 'Nave industrial') {
                appraisal['pr_pct'] = 14
            } else if (appraisal['property_type'].name_es === 'Escuela') {
                appraisal['pr_pct'] = 12
            } else if (appraisal['property_type'].name_es === 'Hotel') {
                appraisal['pr_pct'] = 11
            } else {
                appraisal['pr_pct'] = 12
            }

            if (!appraisal['am_coef']) {
                //Coeficient d'agreujament o millora
                appraisal['am_coef'] = 1.5
            }

            ////Benefici mínim segons la norma (ATASA)
            // Habitatges primera residència --> 18%
            // Habitatges segona residència --> 24%
            // Edificis d'oficines --> 21%
            // Edificis comercials --> 24%
            // Edificis industrials --> 27%
            // Places d'aparcament --> 20%
            // Hotels --> 22%
            // Residències estudiants i 3ª edat --> 24%
            // Altres --> 24%

            if (!appraisal['b2_pct']) {
                // Benefici mercat lliure 2
                appraisal['b2_pct'] = 18
            }

            if (appraisal['property_type'].name_es === 'Piso') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Ático') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Sobreático') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Bajos') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Apartamento') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Loft') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Estudio') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Dúplex') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Triplex') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Plaza de aparcamiento') {
                appraisal['b2_pct'] = 20
            } else if (appraisal['property_type'].name_es === 'Garaje') {
                appraisal['b2_pct'] = 20
            } else if (appraisal['property_type'].name_es === 'Casa adosada') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Casa independiente') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Finca rústica') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Masía') {
                appraisal['b2_pct'] = 18
            } else if (appraisal['property_type'].name_es === 'Piscina') {
                appraisal['b2_pct'] = 24
            } else if (appraisal['property_type'].name_es === 'Trastero') {
                appraisal['b2_pct'] = 24
            } else if (appraisal['property_type'].name_es === 'Pista deportiva') {
                appraisal['b2_pct'] = 24
            } else if (appraisal['property_type'].name_es === 'Club deportivo') {
                appraisal['b2_pct'] = 24
            } else if (appraisal['property_type'].name_es === 'Local con acceso directo') {
                appraisal['b2_pct'] = 24
            } else if (appraisal['property_type'].name_es === 'Local sin acceso directo') {
                appraisal['b2_pct'] = 24
            } else if (appraisal['property_type'].name_es === 'Nave industrial') {
                appraisal['b2_pct'] = 27
            } else if (appraisal['property_type'].name_es === 'Escuela') {
                appraisal['b2_pct'] = 24
            } else if (appraisal['property_type'].name_es === 'Hotel') {
                appraisal['b2_pct'] = 22
            } else {
                appraisal['b2_pct'] = 24
            }

            if (!appraisal['landlord_expenses_pct']) {
                //Despeses del llogater (sobre la renda bruta, per a calcular la renda neta del lloguer)
                appraisal['landlord_expenses_pct'] = 70
            }

            // Tipus d'actualització (i)
            // Habitatges primera residència --> 4.5 %
            // Habitatges segona residència --> 4.5 %
            // Edificis d'oficines --> 7.5 %
            // Edificis comercials --> 5.5 %
            // Edificis industrials --> 7 %
            // Places d'aparcament --> 9 %
            // Hotels --> 6 %
            // Residències estudiants i 3ª edat --> 4 %
            // Altres --> 8 %

            if (!appraisal['i_pct']) {
                // Tipus d'actualització
                appraisal['i_pct'] = 4.5

                if (appraisal['property_type'].name_es === 'Piso') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Ático') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Sobreático') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Bajos') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Apartamento') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Loft') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Estudio') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Dúplex') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Triplex') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Plaza de aparcamiento') {
                    appraisal['i_pct'] = 9
                } else if (appraisal['property_type'].name_es === 'Garaje') {
                    appraisal['i_pct'] = 9
                } else if (appraisal['property_type'].name_es === 'Casa adosada') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Casa independiente') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Finca rústica') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Masía') {
                    appraisal['i_pct'] = 4.5
                } else if (appraisal['property_type'].name_es === 'Piscina') {
                    appraisal['i_pct'] = 8
                } else if (appraisal['property_type'].name_es === 'Trastero') {
                    appraisal['i_pct'] = 8
                } else if (appraisal['property_type'].name_es === 'Pista deportiva') {
                    appraisal['i_pct'] = 8
                } else if (appraisal['property_type'].name_es === 'Club deportivo') {
                    appraisal['i_pct'] = 8
                } else if (appraisal['property_type'].name_es === 'Local con acceso directo') {
                    appraisal['i_pct'] = 5.5
                } else if (appraisal['property_type'].name_es === 'Local sin acceso directo') {
                    appraisal['i_pct'] = 5.5
                } else if (appraisal['property_type'].name_es === 'Nave industrial') {
                    appraisal['i_pct'] = 7
                } else if (appraisal['property_type'].name_es === 'Escuela') {
                    appraisal['i_pct'] = 8
                } else if (appraisal['property_type'].name_es === 'Hotel') {
                    appraisal['i_pct'] = 6
                } else {
                    appraisal['i_pct'] = 4.5
                }

            }

            if (!appraisal['reduction_pct']) {
                // Coeficient de reducció
                appraisal['reduction_pct'] = 0
            }

            if (!appraisal['tenant_life_expectancy_years']) {
                appraisal['tenant_life_expectancy_years'] = 80
            }

            if (!appraisal['tenant_age_years']) {
                // Coeficient de reducció
                appraisal['tenant_age_years'] = 35
            }

            if (!appraisal['usufructuary_age_years']) {
                // Coeficient de reducció
                appraisal['usufructuary_age_years'] = 35
            }

            if (!appraisal['cession_contract_remaining_years']) {
                appraisal['cession_contract_remaining_years'] = 0
            }

            if (!appraisal['cession_gross_monthly_income']) {
                appraisal['cession_gross_monthly_income'] = 0
            }

            if (!appraisal['max_legal_price']) {
                appraisal['max_legal_price'] = 0
            }

            if (!appraisal['max_legal_area']) {
                appraisal['max_legal_area'] = 0
            }



            appraisal['adopted_material_execution_cost'] = this.roundToTwo(appraisal['material_execution_cost'] * appraisal['mec_adjustment_coef'])
            console.log('adopted_material_execution_cost: ')
            console.log(appraisal['adopted_material_execution_cost'])

            appraisal['deprecated_material_execution_cost'] = this.roundToTwo(appraisal['adopted_material_execution_cost'] * ( appraisal['total_depreciation_pct'] / 100 ))
            console.log('deprecated_material_execution_cost: ')
            console.log(appraisal['deprecated_material_execution_cost'])

            appraisal['bc_and_gc_pct'] = appraisal['bc_pct'] + appraisal['gc_pct']
            console.log('bc_and_gc_pct')
            console.log(appraisal['bc_and_gc_pct'])

            appraisal['cc_pct'] = 100 + appraisal['bc_and_gc_pct']
            console.log('cc_pct: ')
            console.log(appraisal['cc_pct'])

            appraisal['b1_pct'] = this.roundToTwo((((appraisal['tlr_pct'] + appraisal['pr_pct']) / 100) * appraisal['am_coef']) * 100)
            console.log('b1_pct: ')
            console.log(appraisal['b1_pct'])

            //Benefici del promotor: el màxim entre b1 i b2
            appraisal['b_pct'] = Math.max(appraisal['b1_pct'], appraisal['b2_pct'])
            console.log('b_pct: ')
            console.log(appraisal['b_pct'])

            appraisal['b_remaining_pct'] = 100 - appraisal['b_pct']
            console.log('\'b_remaining_pct\': ')
            console.log(appraisal['b_remaining_pct'])

            // console.log('tenant_life_expectancy: ' + appraisal['tenant_life_expectancy_years'])
            // console.log('tenant_age_years: ' + appraisal['tenant_age_years'])
            appraisal['tenant_remaining_life_expectancy_years'] = appraisal['tenant_life_expectancy_years'] - appraisal['tenant_age_years']
            // console.log('tenant_remaining_life_expectancy_years: ' + appraisal['tenant_remaining_life_expectancy_years'])
            console.log('tenant_remaining_life_expectancy_years: ')
            console.log(appraisal['tenant_remaining_life_expectancy_years'])

            // console.log('reduction_pct: '+ appraisal['reduction_pct'])
            appraisal['adjustment_coef'] = 1 + this.roundToTwo(appraisal['reduction_pct'] / 100)
            console.log('adjustment_coef: ' + appraisal['adjustment_coef'])

            //Benefici industrial tipus del constructor
            appraisal['bc'] = this.roundToTwo(appraisal['deprecated_material_execution_cost'] * (appraisal['bc_pct'] / 100))
            console.log('bc: ')
            console.log(appraisal['bc'])

            //Despeses generals del constructor
            appraisal['gc'] = this.roundToTwo(appraisal['deprecated_material_execution_cost'] * (appraisal['gc_pct'] / 100))
            console.log('gc: ')
            console.log(appraisal['gc'])

            appraisal['bc_and_gc'] = appraisal['bc'] + appraisal['gc']
            console.log('bc_and_gc: ')
            console.log(appraisal['bc_and_gc'])

            //Costos de construcció
            appraisal['cc'] = this.roundToTwo(appraisal['deprecated_material_execution_cost'] * (appraisal['cc_pct'] / 100))
            console.log('cc: ')
            console.log(appraisal['cc'])

            //Honoraris facultatius, taxes i llicències
            appraisal['htl'] = this.roundToTwo(appraisal['cc'] * (appraisal['htl_pct'] / 100))
            console.log('htl: ')
            console.log(appraisal['htl'])

            //Impostos no recuperables
            appraisal['inr'] = this.roundToTwo(appraisal['cc'] * (appraisal['inr_pct'] / 100))
            console.log('inr: ')
            console.log(appraisal['inr'])

            //Despeses d'administrador del promotor
            appraisal['ga'] = this.roundToTwo(appraisal['cc'] * (appraisal['ga_pct'] / 100))
            console.log('ga: ')
            console.log(appraisal['ga'])

            //Despeses de pòlissa decennal
            appraisal['gpd'] = this.roundToTwo(appraisal['cc'] * (appraisal['gpd_pct'] / 100))
            console.log('gpd: ')
            console.log(appraisal['gpd'])

            //OCT
            appraisal['oct'] = this.roundToTwo(appraisal['cc'] * (appraisal['oct_pct'] / 100))
            console.log('oct: ')
            console.log(appraisal['oct'])

            //Despeses de promoció net ( és a dir, sobre const de construcció depreciat per antiguitat)
            appraisal['gp'] = this.roundToTwo(appraisal['cc'] * (appraisal['gp_pct'] / 100))
            console.log('gp: ')
            console.log(appraisal['gp'])

            //Despeses de promoció brut (sobre cost de construcció a nou)
            appraisal['gpb'] = this.roundToTwo(appraisal['ccb'] * (appraisal['gp_pct'] / 100))
            console.log('gpb: ')
            console.log(appraisal['gpb'])

            //Costos de reposició de la construcció
            appraisal['cc_and_gp'] = appraisal['cc'] + appraisal['gp']
            console.log('cc_and_gp: ')
            console.log(appraisal['cc_and_gp'])

            //Costos de reposició de la construcció
            appraisal['ccb_and_gpb'] = appraisal['ccb'] + appraisal['gpb']
            console.log('ccb_and_gpb: ')
            console.log(appraisal['ccb_and_gpb'])

            //Valor del sòl
            appraisal['f'] = this.roundToTwo((appraisal['adopted_market_unit_value'] * (1 - (appraisal['b_pct'] / 100))) - (appraisal['cc'] + appraisal['gp']))
            if (appraisal['f'] < 0) {
                //alert('Revisar dades: el valor del sòl dóna negatiu amb les dades actuals. S\'ha establert a 0 per evitar errors de càlcul a l\'aplicació')
                appraisal['f'] = 0
            }
            console.log('f: ')
            console.log(appraisal['f'])

            // Cost de Reemplaçament-reposició Brut (CRB)
            appraisal['crb'] = appraisal['f'] + appraisal['ccb'] + appraisal['gpb']
            console.log('crb: ')
            console.log(appraisal['crb'])

            //Cost de construcció depreciat (incloses despes de promoció)
            appraisal['ccd'] = this.roundToTwo((appraisal['ccb'] + appraisal['gpb']) * ( appraisal['total_depreciation_pct'] / 100 ))
            console.log('ccd: ')
            console.log(appraisal['ccd'])

            //********* Cost de Reemplaçament-reposició Net (CRN) en Immoble Acabat
            // var crn_immoble_acabat = (f + (ccd * (depreciacio_total_pct / 100))) * ((100 + ga_pct) / 100);
            // Sòl més cost de construcció depreciat
            appraisal['deprecated_land_and_ccd'] = appraisal['f'] + appraisal['ccd']
            appraisal['finished_realestate_crn'] = this.roundToTwo(appraisal['deprecated_land_and_ccd'] * ((100 + appraisal['ga_pct']) / 100))
            console.log('deprecated_land_and_ccd: ')
            console.log(appraisal['deprecated_land_and_ccd'])
            console.log('finished_realestate_crn')
            console.log(appraisal['finished_realestate_crn'])

            //********** Cost de Reemplaçament-reposició Net (CRN) en Immoble en Construcció
            //OJO PUFO CORRECTE PERO REVISAR AL FER EDIFICIS EN CONSTRUCCIÓ

            //Cost de construcció realitzada
            appraisal['ccr'] = this.roundToTwo((appraisal['ccb'] + appraisal['gpb']) * (appraisal['total_construction_progress_pct'] / 100))
            appraisal['executed_construction_cost'] = appraisal['f'] + appraisal['ccr']
            appraisal['gar'] = (appraisal['f'] + appraisal['ccr']) * ( appraisal['ga_pct'] / 100 )
            appraisal['under_construction_realestate_crn'] = this.roundToTwo(appraisal['executed_construction_cost'] * ((100 + appraisal['ga_pct']) / 100))
            console.log('ccr: ')
            console.log(appraisal['ccr'])
            console.log('executed_construction_cost: ')
            console.log(appraisal['executed_construction_cost'])
            console.log('under_construction_realestate_crn: ')
            console.log(appraisal['under_construction_realestate_crn'])

            // Coeficient de mercat
            appraisal['k'] = this.roundToTwo(appraisal['adopted_market_unit_value'] / appraisal['finished_realestate_crn'])
            console.log('k: ')
            console.log(appraisal['k'])

            //////// VALORS TOTALS

            // Valor total del sòl (mètode de repercussió)
            appraisal['repercussion_method_land_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['f']))
            console.log('repercussion_method_land_value: ')
            console.log(appraisal['repercussion_method_land_value'])

            // Valor de la construccio, mètode del cost, CRB (no inclou el terreny)
            appraisal['cost_method_construction_crb_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['ccb_and_gpb']))
            console.log('cost_method_construction_crb_value: ')
            console.log(appraisal['cost_method_construction_crb_value'])

            // Valor de la construccio, mètode del cost, CRN (no inclou el terreny)
            appraisal['cost_method_construction_crn_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['ccd']))
            console.log('cost_method_construction_crn_value: ')
            console.log(appraisal['cost_method_construction_crn_value'])

            // Valor de l'immoble, mètode del cost, CRB (construcció + sòl)
            appraisal['cost_method_realestate_crb_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['crb']))
            console.log('cost_method_realestate_crb_value: ')
            console.log(appraisal['cost_method_realestate_crb_value'])

            // Valor de l'immoble acabat, mètode del cost, CRN (construcció + sòl)
            appraisal['cost_method_realestate_crn_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['finished_realestate_crn']))
            console.log('cost_method_realestate_crn_value: ')
            console.log(appraisal['cost_method_realestate_crn_value'])

            // Valor de l'immoble en construcció, mètode del cost, CRN (construcció + sòl)
            appraisal['cost_method_unfinished_realestate_crn_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['under_construction_realestate_crn']))
            console.log('cost_method_unfinished_realestate_crn_value: ')
            console.log(appraisal['cost_method_unfinished_realestate_crn_value'])

            if('cost_method_unfinished_realestate_crn_value')

            // Valor de mercat l'immoble, mètode de comparació
            appraisal['comparison_method'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['adopted_market_unit_value']))
            console.log('comparison_method: ')
            console.log(appraisal['comparison_method'])

            // Valor de mercat ajustat
            console.log('adjustment_coef: ' + appraisal['adjustment_coef'])
            appraisal['adjusted_market_value'] = this.roundToTwo(appraisal['comparison_method'] * appraisal['adjustment_coef'])
            console.log('adjusted_market_value: ')
            console.log(appraisal['adjusted_market_value'])

            //Mètode màxim legal
            appraisal['max_legal_method'] = 0
            if (appraisal['protection_boolean']) {
                appraisal['max_legal_method'] = this.roundToTwo(appraisal['max_legal_area'] * this.roundToTwo(appraisal['max_legal_price']))
            }

            console.log('max_legal_method: ')
            console.log(appraisal['max_legal_method'])

            ////// Mètode actualització de renda (Actualitzacio a perpetuïtat)
            appraisal['cession_gross_yearly_income'] = this.roundToTwo(appraisal['cession_gross_monthly_income'] * 12)
            appraisal['cession_net_yearly_income'] = this.roundToTwo(appraisal['cession_gross_monthly_income'] * 12 * (appraisal['landlord_expenses_pct'] / 100))
            appraisal['vc'] = this.roundToTwo(appraisal['cession_net_yearly_income'] / (appraisal['i_pct'] / 100))
            appraisal['income_perpetuity_update_method'] = appraisal['vc']

            console.log('cession_gross_yearly_income: ')
            console.log(appraisal['cession_gross_yearly_income: '])
            console.log('cession_net_yearly_income: ')
            console.log(appraisal['cession_net_yearly_income'])
            console.log('i_pct: ')
            console.log(appraisal['i_pct'])
            console.log('vc: ')
            console.log(appraisal['vc'])
            console.log('income_perpetuity_update_method: ')
            console.log(appraisal['income_perpetuity_update_method'])
            ////// Mètode actualització de rendes esperades
            /// Càlcul de la vida útil
            // Durada restant previsible del contracte (mínim de n1, n2 i n3)

            console.log('cession_contract_remaining_years: ' + appraisal['cession_contract_remaining_years'])
            console.log('remaining_useful_life_years: ' + appraisal['remaining_useful_life_years'])
            console.log('tenant_remaining_life_expectancy_years: ' + appraisal['tenant_remaining_life_expectancy_years'])

            let arr_times = []
            arr_times.push(appraisal['cession_contract_remaining_years'])
            arr_times.push(appraisal['remaining_useful_life_years'])
            arr_times.push(appraisal['tenant_remaining_life_expectancy_years'])
            appraisal['u'] = Math.min.apply(null, arr_times)

            console.log('u: ' + appraisal['u'])

            /// Càlcul del valor residual de l'immoble
            // cost de reposició per contracta -> metode_cost_valor_construccio_crb
            appraisal['residual_depreciation_pct'] = this.roundToTwo(appraisal['u'] / appraisal['useful_life_years'])
            appraisal['residual_depreciation'] = this.roundToTwo(-1 * appraisal['cost_method_construction_crb_value'] * (appraisal['residual_depreciation_pct']))
            // Valor residual de l'immoble al final de la vida útil del contracte
            appraisal['realestate_residual_value'] = this.roundToTwo(appraisal['comparison_method'] + appraisal['residual_depreciation'])

            console.log('residual_depreciation_pct: ')
            console.log(appraisal['residual_depreciation_pct'])
            console.log('residual_depreciation: ')
            console.log(appraisal['residual_depreciation'])
            console.log('realestate_residual_value: ')
            console.log(appraisal['realestate_residual_value'])

            /// Càlcul del valor actual de les rendes futures (A)
            appraisal['i'] = appraisal['i_pct'] / 100
            appraisal['np'] = appraisal['u']
            // Coef. 1 = [(1 + i) ^ n - 1] / [(1 + i) ^ n * i]
            appraisal['coef_1'] = this.roundToTwo((Math.pow((1 + appraisal['i']), appraisal['np']) - 1) / (Math.pow((1 + appraisal['i']), appraisal['np']) * appraisal['i']))
            appraisal['current_future_income_value'] = this.roundToTwo(appraisal['cession_net_yearly_income'] * appraisal['coef_1'])

            console.log('i: ')
            console.log(appraisal['i'])

            console.log('np: ')
            console.log(appraisal['np'])
            console.log('coef_1: ')
            console.log(appraisal['coef_1'])
            console.log('current_future_income_value: ')
            console.log(appraisal['current_future_income_value'])

            /// Càlcul del valor actual del valor de reversió (B)
            appraisal['coef_2'] = this.roundToTwo(Math.pow((1 + appraisal['i']), appraisal['np']))
            appraisal['updated_reversion_value'] = this.roundToTwo(appraisal['realestate_residual_value'] / appraisal['coef_2'])
            console.log('coef_2: ')
            console.log(appraisal['coef_2'])
            console.log('updated_reversion_value')
            console.log(appraisal['updated_reversion_value'])

            ///Càlcul del VALOR PER ACTUALITZACIÓ (A+B)
            appraisal['update_value'] = appraisal['current_future_income_value'] + appraisal['updated_reversion_value']

            console.log('update_value: ')
            console.log(appraisal['update_value'])


            console.log('\'insurance_value\': ')
            console.log(appraisal['insurance_value'])

            // Valor de taxació adoptat per a l'element
            appraisal['realestate_total_adopted_value'] = 0
            appraisal['realestate_adopted_appraisal_method'] = ''

            let crn_under_construction_method_obj = {
                id: 6,
                'bde_code': 'A01',
                'name_ca': 'Cost de Reemplaçament-reposició Net (immoble en construcció)',
                'name_en': 'Net Replacement Cost (building under construction)',
                'name_es': 'Coste de Reposición Neto (inmueble en construcción)',
            }

            let max_legal_method_obj = {
                id: 5,
                'bde_code': 'A12',
                'name_ca': 'Mètode Màxim Legal',
                'name_en': 'Maximum Legal Method',
                'name_es': 'Método Máximo Legal',
            }

            let perpetuity_income_update_method_obj = {
                id: 4,
                'bde_code': 'A09',
                'name_ca': 'Mètode Actualització de Renda a Perpetuïtat',
                'name_en': 'Perpetuity Income Update Method',
                'name_es': 'Método Actualización de Renta a Perpetuidad',
            }

            let expected_income_update_method_obj = {
                id: 3,
                'bde_code': 'A09',
                'name_ca': 'Mètode Actualització de Renda Esperada',
                'name_en': 'Expected Income Update Method',
                'name_es': 'Método Actualización de Renta Esperada'
            }

            let adjusted_comparison_method_obj = {
                id: 2,
                'bde_code': 'A06',
                'name_ca': 'Mètode de Comparació Ajustat',
                'name_en': 'Adjusted Comparison Method',
                'name_es': 'Método de Comparación Ajustado'
            }

            let comparison_method_obj = {
                id: 1,
                'bde_code': 'A06',
                'name_ca': 'Mètode de Comparació',
                'name_en': 'Comparison Method',
                'name_es': 'Método de Comparación'
            }

            if (appraisal['protection_boolean']) {


                if (appraisal['max_legal_method'] <= appraisal['adjusted_market_value']) {

                    if (appraisal['cession_boolean']) {

                        if (appraisal['update_value'] < appraisal['max_legal_method']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['update_value']
                            appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj

                        } else if (appraisal['update_value'] >= appraisal['max_legal_method']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['max_legal_method']
                            appraisal['realestate_adopted_appraisal_method'] = max_legal_method_obj

                        }

                        /*
                        // apliquem sempre el mateix mètode
                        if (appraisal['tenant_remaining_life_expectancy_years'] <= appraisal['cession_contract_remaining_years']) {

                            if (appraisal['income_perpetuity_update_method'] < appraisal['max_legal_method']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['income_perpetuity_update_method']
                                appraisal['realestate_adopted_appraisal_method'] = perpetuity_income_update_method_obj

                            } else if (appraisal['update_value'] >= appraisal['max_legal_method']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['max_legal_method']
                                appraisal['realestate_adopted_appraisal_method'] = max_legal_method_obj

                            }

                        } else if (appraisal['tenant_remaining_life_expectancy_years'] > appraisal['cession_contract_remaining_years']) {

                            if (appraisal['update_value'] < appraisal['max_legal_method']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['update_value']
                                appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj

                            } else if (appraisal['update_value'] >= appraisal['max_legal_method']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['max_legal_method']
                                appraisal['realestate_adopted_appraisal_method'] = max_legal_method_obj

                            }

                        }
                        */

                    } else {

                        appraisal['realestate_total_adopted_value'] = appraisal['max_legal_method']
                        appraisal['realestate_adopted_appraisal_method'] = max_legal_method_obj

                        if(appraisal['total_construction_progress_pct'] < 100){
                            if( appraisal['cost_method_unfinished_realestate_crn_value'] < appraisal['max_legal_method']){
                                appraisal['realestate_total_adopted_value'] = appraisal['cost_method_unfinished_realestate_crn_value']
                                appraisal['realestate_adopted_appraisal_method'] = crn_under_construction_method_obj
                            }
                        }

                    }

                } else if (appraisal['max_legal_method'] > appraisal['adjusted_market_value']) {

                    if (appraisal['cession_boolean']) {

                        if (appraisal['tenant_remaining_life_expectancy_years'] <= appraisal['u']) {

                            if (appraisal['income_perpetuity_update_method'] <= appraisal['adjusted_market_value']) {

                                // appraisal['realestate_total_adopted_value'] = appraisal['income_perpetuity_update_method']
                                // appraisal['realestate_adopted_appraisal_method'] = perpetuity_income_update_method_obj

                                appraisal['realestate_total_adopted_value'] = appraisal['update_value']
                                appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj

                            } else if (appraisal['update_value'] > appraisal['adjusted_market_value']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value']
                                appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj
                                if (appraisal['reduction_pct'] >= 0) {
                                    appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj
                                }

                            }

                        } else if (appraisal['tenant_remaining_life_expectancy_years'] > appraisal['u']) {

                            if (appraisal['update_value'] <= appraisal['adjusted_market_value']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['update_value']
                                appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj

                            } else if (appraisal['update_value'] > appraisal['adjusted_market_value']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value']
                                appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj
                                if (appraisal['reduction_pct'] >= 0) {
                                    appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj
                                }

                            }
                        }
                    } else {

                        appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value']
                        appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj
                        if (appraisal['reduction_pct'] >= 0) {
                            appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj
                        }

                        if(appraisal['total_construction_progress_pct'] < 100){
                            if( appraisal['cost_method_unfinished_realestate_crn_value'] < appraisal['adjusted_market_value']){
                                appraisal['realestate_total_adopted_value'] = appraisal['cost_method_unfinished_realestate_crn_value']
                                appraisal['realestate_adopted_appraisal_method'] = crn_under_construction_method_obj
                            }
                        }

                    }
                }

            } else {

                if (appraisal['cession_boolean']) {

                    if (appraisal['tenant_remaining_life_expectancy_years'] <= appraisal['u']) {

                        if (appraisal['income_perpetuity_update_method'] <= appraisal['adjusted_market_value']) {

                            // appraisal['realestate_total_adopted_value'] = appraisal['income_perpetuity_update_method']
                            // appraisal['realestate_adopted_appraisal_method'] = perpetuity_income_update_method_obj
                            appraisal['realestate_total_adopted_value'] = appraisal['update_value']
                            appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj

                        } else if (appraisal['update_value'] > appraisal['adjusted_market_value']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value']
                            appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj
                            if (appraisal['reduction_pct'] >= 0) {
                                appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj
                            }

                        }

                    } else if (appraisal['tenant_remaining_life_expectancy_years'] > appraisal['u']) {

                        if (appraisal['update_value'] <= appraisal['adjusted_market_value']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['update_value']
                            appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj

                        } else if (appraisal['update_value'] > appraisal['adjusted_market_value']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value']
                            appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj
                            if (appraisal['reduction_pct'] >= 0) {
                                appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj
                            }

                        }
                    }
                } else {

                    appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value']
                    appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj
                    if (appraisal['reduction_pct'] >= 0) {
                        appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj
                    }

                    if(appraisal['total_construction_progress_pct'] < 100){
                        if( appraisal['cost_method_unfinished_realestate_crn_value'] < appraisal['adjusted_market_value']){
                            appraisal['realestate_total_adopted_value'] = appraisal['cost_method_unfinished_realestate_crn_value']
                            appraisal['realestate_adopted_appraisal_method'] = crn_under_construction_method_obj
                        }
                    }

                }
            }

            // Valor del dret d'ús
            /*
És evident que no és el mateix un habitatge que està lliure vacu i expedit que una que està ocupada. Intentem establir per tant un criteri que serveixi per determinar el menor valor que se li ha de donar per aquest concepte. Tot i que no és el cas estricte d'un usdefruit (en el qual la usuària podria arrendar l'habitatge a una tercera persona), el perjudici econòmic -perdre les rendes que podria generar l'habitatge- és equivalent, a efectes merament valoratius.
Per això fem la valoració segons els criteris de nua propietat i usdefruit, a saber:
Usdefruit. L'usdefruit és un dret que es constitueix a favor d'una persona, usufructuari, que adquireix la utilitat de la cosa, pertanyent, però, la propietat a una altra, el nu propietari. El dret pot constituir amb caràcter temporal o vitalici, sent la valoració a efectes de l'IP diferent en cada cas.
Usdefruit temporal. El valor s'ha d'estimar en un 2% per cada any que resti de durada del contracte, amb un màxim del 70%. La nua propietat es valorarà en la resta del valor del bé fins al 100%.
Usdefruit vitalici. Es pren el 70% del valor del bé si l'usufructuari té menys de 20 anys, minorant el percentatge en un 1% per cada any en què, a la data de la meritació, superi aquesta edat, amb el mínim del 10%. La nua propietat es valorarà en la resta del valor del bé fins al 100%-
*/

            //Coef Vu (valor mínim 0.1)
            appraisal['vu_coef'] = this.roundToTwo(Math.max(0.1, 0.7 - (0.01 * (appraisal['usufructuary_age_years'] - 20))))
            appraisal['usufruct_value'] = this.roundToTwo(appraisal['vu_coef'] * appraisal['realestate_total_adopted_value'])
            appraisal['bare_ownership_value'] = this.roundToTwo((1 - appraisal['vu_coef']) * appraisal['realestate_total_adopted_value'])

            console.log('vu_coef: ')
            console.log(appraisal['vu_coef'])
            console.log('usufruct_value: ')
            console.log(appraisal['usufruct_value'])
            console.log('bare_ownership_value: ')
            console.log(appraisal['bare_ownership_value'])

            console.log('\'realestate_total_adopted_value\': ')
            console.log(appraisal['realestate_total_adopted_value'])
            console.log('realestate_adopted_appraisal_method: ')
            console.log(appraisal['realestate_adopted_appraisal_method'])



            ///Valor assegurança
            //Serà el valor de construcció + les despeses d'administració del promotor per la superfície adoptada

            // appraisal['insurance_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['cc_and_gp']))

            appraisal['insurance_value'] = this.roundToTwo(appraisal['ccb_and_gpb'] * appraisal['adopted_area'])


            // cost_method_realestate_crb_value

            appraisal['insurance_value_rd_685_1982'] = this.roundToTwo(appraisal['cost_method_realestate_crb_value'] - appraisal['repercussion_method_land_value'])
            appraisal['insurance_value_rd_716_2009'] = this.roundToTwo(appraisal['realestate_total_adopted_value'] - appraisal['repercussion_method_land_value'])

            console.log('insurance_value_rd_685_1982:')
            console.log(appraisal['insurance_value_rd_685_1982'])

            console.log('insurance_value_rd_716_2009:')
            console.log(appraisal['insurance_value_rd_716_2009'])


            console.log('appraisal calculations done!')


            return appraisal
        }
    }
}







// WEBPACK FOOTER //
// ./src/mixins/index.js